let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gS3s6")).then(() => parcelRequire('cLlaG'));